module.exports = __webpack_public_path__ + "img/logo.c3859c41.png";